import { formatTestId } from "@nimble/ts-formatters/format-test-ids";

import SchoolDetailDistanceFromLocation from "@/components/shared/school/school-details/school-detail-distance-from-location";
import { schoolStatsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";

type SchoolDetailLocationProps = {
  schoolId: string;
  city: string;
  state: string;
  distanceFromLocation?: number;
  directionsUrl: string;
};

export default function SchoolDetailLocation({
  schoolId,
  city,
  state,
  distanceFromLocation,
  directionsUrl,
}: SchoolDetailLocationProps) {
  return (
    <span
      data-testid={`${schoolStatsTestIds.SCHOOL_LOCATION}-${formatTestId(
        schoolId,
      )}`}
    >
      <span className="text-xs sm:text-sm font-medium text-ink-emphasis">
        {city}, {state}
      </span>
      {distanceFromLocation !== undefined && (
        <>
          {" "}
          <SchoolDetailDistanceFromLocation
            schoolId={schoolId}
            distanceFromLocation={distanceFromLocation}
            directionsUrl={directionsUrl}
          />
        </>
      )}
    </span>
  );
}
